const BLOCKED_DOMAINS = new Set([
  // Disposable / temp email providers
  'mailinator.com', 'guerrillamail.com', '10minutemail.com', 'temp-mail.org',
  'tempmail.com', 'yopmail.com', 'sharklasers.com', 'trashmail.com',
  'dispostable.com', 'fakeinbox.com', 'maildrop.cc', 'getnada.com',
  'moakt.com', 'throwawaymail.com', 'emailondeck.com', 'mintemail.com',
  'spamgourmet.com', 'mytemp.email', 'burnermail.io', 'tempmailo.com',
  // Placeholder / test domains
  'example.com', 'example.org', 'example.net', 'test.com', 'invalid.com',
  'localhost', 'domain.com', 'email.com', 'fake.com',
]);

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function validateEmail(email) {
  if (!email || !email.trim()) {
    return 'Email address is required.';
  }

  const trimmed = email.trim().toLowerCase();

  if (!EMAIL_REGEX.test(trimmed)) {
    return 'Please enter a valid email address.';
  }

  const domain = trimmed.split('@')[1];

  if (BLOCKED_DOMAINS.has(domain)) {
    return 'Please use a real email address. Disposable or temporary email addresses are not allowed.';
  }

  // No dots-only or consecutive dots in local part
  const local = trimmed.split('@')[0];
  if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) {
    return 'Please enter a valid email address.';
  }

  return null; // valid
}
